export default __webpack_public_path__ + "static/media/notFound.ee002ad9.png";